"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfiniteLoaderMobile_1 = require("./InfiniteLoaderMobile");
exports.default = InfiniteLoaderMobile_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/InfiniteLoader/InfiniteLoaderMobile/index.js
// module id = 521
// module chunks = 8